import { create } from "zustand";
import { DCAuthState } from "./types";

export const useDCAuthStore = create<DCAuthState>((set) => ({
  user: null,
  loading: true,
  error: null,
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}));
